
import { fns, libTypes } from "@holta/lib";
import { useStore } from "../../config/store";
import { getEditOrder } from "./getEditOrder";
import {create} from 'mutative';

export const setProductionStatus = (productionStatus: libTypes.Order['productionStatus']) => {

    const editOrder = getEditOrder();

    useStore.setState({
        editOrder : create(editOrder, draft => {
            draft.newValues.order.productionStatus = fns.order.set.productionStatus(productionStatus);
        })
    });
};